import { fetchCachedHelper } from '../../../api/api'
import { browseClassesActions } from './browseClassesSlice'

export const getClasses = params => async dispatch => {
    dispatch(browseClassesActions.getClassesRequest())
    try {
        const response = await fetchCachedHelper(`Inclass`, {
            params,
        })
        let { data: classes, paging } = response.data
        dispatch(
            browseClassesActions.getClassesRequestSuccess({ classes, paging })
        )
    } catch (e) {
        dispatch(browseClassesActions.getClassesRequestError(e.message))
    }
}
